import React from "react";

const DesktopTableSkeleton = ({ rows = 5, columns = 6 }) => {
  return (
    <React.Fragment>
      {Array.from({ length: rows }).map((_, i) => (
        <tr
          key={i}
          className="hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors"
        >
          {Array.from({ length: columns }).map((_, j) => (
            <td key={j} className="px-6 py-4">
              <div className="h-4 w-full bg-gray-200 dark:bg-slate-700 rounded-md animate-pulse"></div>
            </td>
          ))}
        </tr>
      ))}
    </React.Fragment>
  );
};

export default DesktopTableSkeleton;